<template>
  <fieldset class="flex justify-between items-center gap-2">
    <div
      v-for="option in options"
      :key="option.id"
      class="radio-option flex flex-col items-start justify-start gap-4 p-4 w-full bg-cadet-gray bg-opacity-5 border rounded-lg cursor-pointer min-h-[120px]"
      role="radio"
      :aria-checked="isSelected(option.id)"
      :aria-labelledby="`label-${option.id}`"
      tabindex="0"
      :class="[
        isSelected(option.id)
          ? 'active transition-all duration-300'
          : 'border-transparent'
      ]"
      @click="selectOption(option.id)"
      @keydown.space.prevent="onKeyPress($event, option.id)"
      @keydown.enter.prevent="onKeyPress($event, option.id)"
    >
      <slot
        name="content"
        :option="option"
        :is-selected="isSelected(option.id)"
      />
      <input
        type="radio"
        class="hidden"
        v-model="model"
        :name="option.name"
        :value="option.id"
      />
    </div>
  </fieldset>
</template>
<script setup lang="ts">
  type Option = {
    id: number;
    name: string;
    description: string;
    [key: string]: any;
  };

  const emit = defineEmits(['update:modelValue']);

  defineProps({
    options: {
      type: Array as () => Array<Option>,
      required: true
    }
  });

  const model = defineModel<number>({
    default: 1,
    type: Number
  });

  const isSelected = (value: number) => model.value === value;
  const selectOption = (value: number) => {
    model.value = value;
    emit('update:modelValue', value);
  };

  const onKeyPress = (event: KeyboardEvent, value: number) => {
    if (event.key === 'Enter' || event.key === ' ') {
      selectOption(value);
    }
  };
</script>

<style scoped>
  .active {
    border: 1px solid rgba(175, 230, 20, 0.5);
    background: linear-gradient(
      180deg,
      rgba(110, 190, 0, 0.15) 0%,
      rgba(185, 192, 202, 0.05) 100%
    );
  }

  .radio-option {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }
</style>
